import { render, staticRenderFns } from "./notice-details.vue?vue&type=template&id=7e07d327&scoped=true"
import script from "./notice-details.vue?vue&type=script&lang=js"
export * from "./notice-details.vue?vue&type=script&lang=js"
import style0 from "./notice-details.vue?vue&type=style&index=0&id=7e07d327&prod&lang=scss&scoped=true"
import style1 from "./notice-details.vue?vue&type=style&index=1&id=7e07d327&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_pwz6xkwfkuu76k24ttivynkur4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e07d327",
  null
  
)

/* custom blocks */
import block0 from "./notice-details.vue?vue&type=custom&index=0&blockType=vue-filename-injector"
if (typeof block0 === 'function') block0(component)

export default component.exports